export default __webpack_public_path__ + "static/media/lilo-min.6a212a42.png";